import { agentStatusDotClass, agentStatusLabel } from './agentDisplay'

export function AgentStatusDot({
  status,
  size = 'md',
  className = '',
}: {
  status?: string
  size?: 'sm' | 'md'
  className?: string
}) {
  if (!status) return null
  const dim = size === 'sm' ? 'h-1.5 w-1.5' : 'h-2 w-2'
  return (
    <span
      className={['inline-block shrink-0 rounded-full', dim, agentStatusDotClass(status), className]
        .filter(Boolean)
        .join(' ')}
      title={agentStatusLabel(status)}
      aria-label={agentStatusLabel(status)}
    />
  )
}

/** 与单行 12px/leading-5 文本垂直居中对齐的色点槽 */
export function AgentStatusDotSlot({
  status,
  size = 'sm',
}: {
  status?: string
  size?: 'sm' | 'md'
}) {
  if (!status) return null
  return (
    <span className="inline-flex h-5 w-2.5 shrink-0 items-center justify-center" aria-hidden={false}>
      <AgentStatusDot status={status} size={size} />
    </span>
  )
}
